import React from 'react';
import '../assets/css/BlogSkeleton.css';

const RecentPostsSkeleton = () => {
  return (
    <div className="recent-posts-skeleton">
      {[1, 2, 3, 4].map((item) => (
        <div key={item} className="recent-post-skeleton-item">
          <div className="skeleton-thumb"></div>
          <div className="skeleton-content">
            <div className="skeleton-line short"></div>
            <div className="skeleton-line tiny"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RecentPostsSkeleton;
